import VueRouter from 'vue-router'

import NotFoundPage from "./views/NotFound.vue"
import Privacy from "./views/Privacy.vue"

import AccountRoutes from "./routes/account.routes"
import ClientRoutes from "./routes/client.routes"
import AdminRoutes from "./routes/admin.routes"

import allRoutes from './routes/all.routes'

const routes = [

    ...AccountRoutes,
    ...ClientRoutes,
    ...AdminRoutes,

    {
        path: "*",
        component: NotFoundPage
    }, 
    {
        path: "/privacy.html",
        component: Privacy,
        meta: {
            layout: 'emptyLayout',
            title: 'Политика конфиденциальности'
        }
    }
];
const router = new VueRouter({
    mode: 'history',
    routes: routes
});

router.beforeEach((to, from, next) => {

    let isFromFeed = from.path == allRoutes.Client.Feed;
    let isToAudit = to.path == allRoutes.Client.Audit.Index;
    
    // если переход из Ленты на Просмотр аудита
    if(isFromFeed && isToAudit && to.params.title) {

        document.title = to.params.title;
        to.meta.title = to.params.title;
        setStorage(to.params.title);

    } // если переход на экран Просмотр аудита из любых экранов
    else if(isToAudit && !to.meta.title) {

        to.meta.title = getStorage();
        document.title = getStorage();
    }
    else 
        document.title = to.meta.title

    let isExistsBackLink = to.path != allRoutes.Client.About.Index &&
                           to.path != allRoutes.Client.Settings.Index &&
                           to.path != allRoutes.Client.Help.Index &&
                           to.path != allRoutes.Client.Feed &&
                           to.path != allRoutes.Client.Audit.Add &&
                           to.path != allRoutes.Client.Audit.Index &&
                           to.path != allRoutes.Client.TradePoints.Index;

    if(!isExistsBackLink) {
        next();
        return;
    }
    
    let isToForm = to.path == allRoutes.Client.Form.Index;
    let isToFormAnswer = to.path == allRoutes.Client.Form.Answer;

    let isToGallery = to.path == allRoutes.Client.Gallery.Index;
    let isToGalleryEdit = to.path == allRoutes.Client.Gallery.Edit;

    let isFromForm = from.path == allRoutes.Client.Form.Index;
    let isFromTT = from.path == allRoutes.Client.TradePoints.Index;
    let isFromTTEdit = from.path == allRoutes.Client.TradePoints.Edit;

    let isToCreateTask = to.path == allRoutes.Client.Form.CreateTask;
    let isToTTView = to.path == allRoutes.Client.TradePoints.View;
    let isToTTEdit = to.path == allRoutes.Client.TradePoints.Edit;
    
    if(isToForm)
        to.meta.backLink = `${allRoutes.Client.Audit.Index}?id=${to.query.auditId}`

    if(isToFormAnswer || isToCreateTask || isToGallery)
        to.meta.backLink = `${allRoutes.Client.Form.Index}?id=${to.query.formId}&auditId=${to.query.auditId}`


    if(isToGalleryEdit)
        to.meta.backLink = `${allRoutes.Client.Gallery.Index}?auditId=${to.query.auditId}&formId=${to.query.formId}`   


    if(isToTTEdit || isToTTView)
        to.meta.backLink = `${allRoutes.Client.TradePoints.Index}?auditId=${to.query.auditId}`


    if((isToTTView && (isFromForm || isFromTT)) || (isToCreateTask && isFromForm))
        to.meta.backLink = from.fullPath;

    if(isToTTView && isFromTTEdit)
        to.meta.backLink = from.meta.backLink;
    
    next()
})

function getStorage() {
    return localStorage.getItem('meta.title');
}

function setStorage(value) {
    localStorage.setItem('meta.title', value); 
}


export default router